export const SET_KEYCLOAK_DATA = 'keycloak//SET_KEYCLOAK_DATA'
export const SET_KEYCLOAK_IDP = 'keycloak//SET_KEYCLOAK_IDP'
export const SET_KEYCLOAK_IDP_HINT = 'keycloak//SET_KEYCLOAK_IDP_HINT'
export const SET_IS_LOGGED = 'keycloak//SET_IS_LOGGED'

export function setData(data) {
  return {
    type: SET_KEYCLOAK_DATA,
    payload: data,
  }
}

export function setIdp(idp) {
  return {
    type: SET_KEYCLOAK_IDP,
    payload: idp,
  }
}

export function setIdpHint(idpHint) {
  return {
    type: SET_KEYCLOAK_IDP_HINT,
    payload: idpHint,
  }
}

export function setIsLogged(isLogged) {
  return {
    type: SET_IS_LOGGED,
    payload: isLogged,
  }
}

export const keycloakActions = {
  setData,
  setIdp,
  setIdpHint,
  setIsLogged,
}

export function getKeycloakData(state) {
  return state.keycloak.data
}
export function getKeycloakIdp(state) {
  return state.keycloak.idp
}
export function getIsLogged(state) {
  return state.keycloak.isLogged
}

const initialState = {
  data: {},
  idp: null,
  idpHint: null,
  isLogged: false,
}

export function keycloakReducer(state = initialState, action) {
  switch (action.type) {
    case SET_KEYCLOAK_DATA:
      return {
        ...state,
        data: action.payload,
      }

    case SET_KEYCLOAK_IDP:
      return {
        ...state,
        idp: action.payload,
      }

    case SET_KEYCLOAK_IDP_HINT:
      return {
        ...state,
        idpHint: action.payload,
      }
    case SET_IS_LOGGED:
      return {
        ...state,
        isLogged: action.payload,
      }

    default:
      return state
  }
}
